import { CookieConsentService } from '@core/services/cookie-consent.service';

export function cookieConsentServiceFactory(
  cookieConsentService: CookieConsentService,
) {
  return (): Promise<any> => {
    return cookieConsentService.init();
  };
}
